import React from 'react';
import { Prompt } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as printingActions from '../../redux/actions/CheckPrintingActions';
import { getApplications } from '../../redux/actions/ApplicationsActions';
import { toastr } from 'react-redux-toastr';

import NavigationComponent from '../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../commonComponents/util/LoadingSpinner';
import PrintingTable from './PrintingTable';

class PrintingPage extends NavigationComponent {
    constructor(props) {
        super(props);

        const checks = this.props.printing.data;
        
        this.state = {
            checkPrints: checks,
            printsCancelled: [],
            printsConfirmed: [],
            reprintRangeFrom: checks.length ? checks[0].checkNumber : '',
            reprintRangeTo: checks.length ? checks[checks.length - 1].checkNumber : '',
            showReprintDropdown: false
        };
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    markPrintsCancelled(checkNumbers) {
        this.setState({ printsCancelled: checkNumbers });
    }

    markPrintsConfirmed(checkNumbers) {
        this.setState({ printsConfirmed: checkNumbers });
    }

    async reprint(printJobIds) {
        this.setState({ showReprintDropdown: false });

        if (printJobIds.length) {
            toastr.info('Printing in progress', `${printJobIds.length} check${printJobIds.length > 1 ? "s" : ""} printing.`, { timeOut: 0 }); 
            await this.props.actions.printChecks('reprints', this.props.printing.printerId, { printJobIds });            
            toastr.removeByType('info');

            if (this.props.printing.success) {
                toastr.success('Printing completed.');
            } else {
                toastr.error("Something went wrong", "The print job could not be completed.  Please try again.");
            }
        }
    }

    async confirmPrinting() {
        const { checkPrints, printsCancelled, printsConfirmed } = this.state;

        if(!checkPrints.length) return;

        let success = true;
        let updatedCheckPrints = [ ...checkPrints ], updatedPrintsCancelled = [], updatedPrintsConfirmed = [];
        
        if(printsConfirmed.length) {
            const confirmedPrintJobIds = checkPrints
                .filter(ck => printsConfirmed.indexOf(ck.checkNumber) >= 0)
                .map(ck => ck.printJobId);
            await this.props.actions.confirmChecksPrinted(confirmedPrintJobIds);
            if(!this.props.confirming.success) {
                success = false;
            } else {
                updatedCheckPrints = updatedCheckPrints.filter(ck => confirmedPrintJobIds.indexOf(ck.printJobId) < 0);
                updatedPrintsConfirmed = []
            }
        }
        if(printsCancelled.length) {
            const cancelledPrintJobIds = checkPrints
                .filter(ck => printsCancelled.indexOf(ck.checkNumber) >= 0)
                .map(ck => ck.printJobId);
            await this.props.actions.confirmChecksPrinted(cancelledPrintJobIds, true);
            if(!this.props.confirming.success) {
                success = false;
            } else {
                updatedCheckPrints = updatedCheckPrints.filter(ck => cancelledPrintJobIds.indexOf(ck.printJobId) < 0);
                updatedPrintsCancelled = []
            }
        }

        this.setState({
            checkPrints: updatedCheckPrints,
            printsCancelled: updatedPrintsCancelled,
            printsConfirmed: updatedPrintsConfirmed
        });

        if (success) {
            if(checkPrints[0].applicationId) { //application checks printing
                if(printsConfirmed.length) {
                    toastr.success(`Printing completed - ${printsConfirmed.length > 1 ? "Applications have" : "Application has"} been marked paid.`);
                }
                this.props.actions.getApplications(1, this.props.applicationsTable.resultsView, this.props.applicationsTable.sort);
                this.pushRoute('/applications');
            } else { //blank checks printing
                if(printsConfirmed.length) {
                    toastr.success('Printing completed.');
                }
                this.pushRoute('/settings/printing');
            }
        } else {
            toastr.error('Something went wrong', 'This action could not be completed.  Please try again.');
        }
    }

    render() {
        const { checkPrints, printsCancelled, printsConfirmed } = this.state;
        
        return (
            <div className="secondary-page">
                <Prompt when={(printsCancelled.length + printsConfirmed.length) !== checkPrints.length} message="Are you sure you'd like to leave this page before confirming printing?  You will not be able to confirm printing at a later point." />
                <div className="secondary-page-header">
                    <div className="container flex-justify flex-center">
                        <div className="flex-one flex">
                            <h4 className="page-header">Printing <span className="printing-tag">{checkPrints.length}</span></h4>
                        </div>
                    </div>
                </div>
                <div className="relative">
                    <div className="thead-background"></div>
                </div>
                <div className="container secondary-page-content printing-page-content">
                    <PrintingTable
                        checkPrints={checkPrints}
                        printsCancelled={printsCancelled}
                        printsConfirmed={printsConfirmed}
                        markPrintsCancelled={this.markPrintsCancelled.bind(this)}
                        markPrintsConfirmed={this.markPrintsConfirmed.bind(this)}
                        reprint={this.reprint.bind(this)} />
                </div>
                {checkPrints.length > 0 && <div className="secretary-page-footer">
                    <div className="flex-justify container">
                        <p className="small-text">Total {checkPrints.length} Item{checkPrints.length > 1 ? "s" : ""}</p>
                        {(printsCancelled.length + printsConfirmed.length) === checkPrints.length &&
                            (this.props.confirming.loading ? <LoadingSpinner height="20" /> :
                                <button className="btn btn-accent2" onClick={this.confirmPrinting.bind(this)}>Finish</button>
                            )
                        }
                    </div>
                </div>}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        printing: state.checkPrinting.printing,
        confirming: state.checkPrinting.confirmPrinting,
        applicationsTable: state.applicationsTable
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...printingActions, getApplications }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintingPage);


// WEBPACK FOOTER //
// ./src/components/printingComponents/PrintingPage.jsx